<template>
  <v-container v-bind="containerConfig" v-if="loaded" :class="[!showBreadcrumbs && 'pt-3']">
    <i4proBreadcrumbs />
    <component :is="component" :page="dataPage" :context="dataMode" />
  </v-container>
</template>

<script>
import { COMPONENT_TYPE } from '@/enums/types';
import * as HANDLERS from '@/helpers/types/handlers';

import store from '@/store';
import eventBus from 'vue-option-events';

export default {
  components: {
    i4proForm: () => import('@/components/layouts/i4pro-form'),
    i4proList: () => import('@/components/layouts/i4pro-list'),
    i4proBreadcrumbs: () => import('@/components/breadcrumbs/i4pro-breadcrumbs')
  },

  props: {
    page: { type: String, required: false },
    mode: { type: String, required: false }
  },

  data() {
    return {
      dataPage: this.page,
      dataMode: this.mode
    };
  },

  async created() {
    await store.dispatch('page/load', { page: this.dataPage, mode: this.dataMode });
    await eventBus.$emit(HANDLERS.ENABLE_FOOTER);
  },

  computed: {
    component() {
      let mode = store.getters['page/mode'](this.dataPage);

      this.dataMode = mode;

      return COMPONENT_TYPE[mode == 'list' ? 'list' : 'form'];
    },

    loaded() {
      return store.getters['page/loaded'](this.dataPage);
    },

    currentMenuPage: () => store.getters['menu/currentPage'],

    currentMenuMode: () => store.getters['menu/currentMode'],

    containerConfig: () => store.getters['layout/getConfigLayout'].container,

    showBreadcrumbs() {
      const namePage = store.getters['menu/currentPage'];
      const breadcrumbs = store.getters['page/showBreadcrumbs'](namePage);

      if (breadcrumbs == undefined || breadcrumbs == null) {
        return true;
      }

      return breadcrumbs;
    }
  },

  events: {
    [HANDLERS.CHANGE_PAGE]: 'changePage'
  },

  watch: {
    currentMenuPage(newValue) {
      this.dataPage = newValue;
    },

    currentMenuMode(newValue) {
      this.dataMode = newValue;
    }
  },

  methods: {
    changePage(params) {
      this.dataPage = params.page;
      this.dataMode = params.mode;
    }
  },

  beforeDestroy: () => store.dispatch('page/clear')
};
</script>
